export enum Civility {
  MR = 'MR',
  MS = 'MS',
}
